export function kliknalMenuDolne() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-ga-event-kliknal-menu-dolne]');
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const title =
            target.querySelector('span')?.textContent.trim() ||
            target.textContent.trim() ||
            '';

        const url = target.getAttribute('href') || '';

        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;

        window.dataLayer.push({
            event: 'kliknal_menu_dolne',
            title: title,
            clicked_url: url,
            page_url: currentUrl,
        });
    });
}
